import { useState } from "react";
import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AnimatedCol from "../../../../components/AnimatedCol";
import ContentExpansion from "../../../../components/ContentExpansion";
import Headline from "../../../../components/UI/Headline";
import MainArea from "../../../../components/UI/MainArea";
import { COMPRESSION_PILE, TENSION_PILE } from "../../../../constants.js";
import {
  selectFrontendState,
  selectLoadType,
  setFrontendState,
} from "../../../../store/slices/fhwaSlice";
import AllowableLoad from "./AllowableLoad";
import AllowableLoadDesignCheck from "./AllowableLoadDesignCheck";
import AreaOfGrout from "./AreaOfGrout";
import BarData from "./BarData";
import DesignLoad from "./DesignLoad";
import DraggableTableDrillbits from "./DraggableTableDrillbits";
import DrillBitDiameter from "./DrillBitDiameter";
import FactorOfSafety from "./FactorOfSafety";
import GroutStrength from "./GroutStrength.jsx";
import InfoBoxCompression from "./InfoBoxCompression";
import InfoBoxTension from "./InfoBoxTension";
import LoadType from "./LoadType.jsx";
import MeasurementTypeSelection from "./MeasurementTypeSelection";
import SafetyFactor from "./SafetyFactor";
import SelectedLoadCarryingElement from "./SelectedLoadCarryingElement.jsx";
import UltimateLoad from "./UltimateLoad";

export default function Inner() {
  const { t } = useTranslation("translation");

  const loadType = useSelector(selectLoadType);
  const { _, showBarDataDetails } = useSelector(selectFrontendState);
  const [showModal, setShowBohrkronenTable] = useState(false);

  return (
    <MainArea>
      <Headline isPrimary text={t("inner.headline")} />

      <div className="mt-5">
        <MeasurementTypeSelection />
        <LoadType />

        <Row>
          {loadType === COMPRESSION_PILE && <InfoBoxCompression />}
          {loadType === TENSION_PILE && <InfoBoxTension />}
        </Row>

        <br />
      </div>

      <div className="mt-5">
        <AnimatedCol>
          <Headline text={t("aashto.inner.Pd Calculation_pdf")} />
        </AnimatedCol>

        <AnimatedCol>
          <DesignLoad />
        </AnimatedCol>

        <AnimatedCol>
          <FactorOfSafety />
        </AnimatedCol>

        <AnimatedCol>
          <UltimateLoad />
        </AnimatedCol>
      </div>

      <div className="mt-5">
        <ContentExpansion
          expand={showBarDataDetails}
          reducer={(val) => setFrontendState({ showBarDataDetails: val })}
        />
        <AnimatedCol>
          <Headline text={t("aashto.inner.Fd Verification of the load-bearing capacity")} />
        </AnimatedCol>
        <AnimatedCol>
          <SelectedLoadCarryingElement />
        </AnimatedCol>
        <Row>
          {/* HACK: 0px to keep the row small when the 'DraggableTableDrillbits' is visible */}
          <div className="col-md-4 offset-md-8" style={{ height: "0px" }}>
            <DraggableTableDrillbits show={showModal} setShow={setShowBohrkronenTable} />
          </div>
        </Row>
        <AnimatedCol>
          <BarData isVisible={showBarDataDetails} />
        </AnimatedCol>
        <AnimatedCol>
          <DrillBitDiameter showModal={setShowBohrkronenTable} />
        </AnimatedCol>

        {loadType === COMPRESSION_PILE && (
          <AnimatedCol>
            <GroutStrength />
          </AnimatedCol>
        )}

        <AnimatedCol>
          <AreaOfGrout />
        </AnimatedCol>

        <div className="mt-5">
          <AnimatedCol>
            <SafetyFactor />
          </AnimatedCol>
        </div>

        <div className="mt-5">
          <AnimatedCol>
            <AllowableLoad />
          </AnimatedCol>
        </div>
        <div className="mt-4">
          <AnimatedCol>
            <AllowableLoadDesignCheck />
          </AnimatedCol>
        </div>
      </div>
    </MainArea>
  );
}
